module.exports = __webpack_public_path__ + "static/img/ios.43bc1343.png";